import React from "react";
import MailIcon from "../assets/images/meesman/budget-invest-icon.svg";

export const MailButton = () => (
  <a
    href="mailto:hi@flowyour.money"
    target="_self"
    className="mail-button">
    <img src={MailIcon} alt="Mail us" /></a>
)